import { useCallback } from 'react';
import { mediaModuleUrl, mediaRoutes } from 'common/services';

type P = {
  id: string;
  size?: string;
  type: string;
};

export const useGetMediaSourceVariant = () =>
  useCallback(
    ({ id, size = 'medium', type }: P) => new URL(mediaRoutes.resourceVariant({ id, size, type }), mediaModuleUrl).href,
    [],
  );
